//
//
//
//
//
//
var script = {
  name: 'TabItem',
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    selected: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    stretch: {
      type: Boolean,
      default: false
    },
    inactive: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hideTooltip: false
    };
  },

  methods: {
    onClick() {
      if (!this.disabled && !this.inactive) {
        this.$emit('input', this.id);
      }
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Tabs/Tab.vue_rollup-plugin-vue=script.js